import React from 'react';
import { 
  Heart, Target, Flame, Share2, Trophy, Brain, Lightbulb,
  type Icon as LucideIcon
} from 'lucide-react';

interface AchievementBadgeProps {
  icon: string;
  size?: number;
  className?: string;
}

const iconMap: Record<string, LucideIcon> = {
  heart: Heart,
  target: Target,
  flame: Flame,
  share: Share2,
  trophy: Trophy,
  brain: Brain,
  lightbulb: Lightbulb
};

const AchievementBadge: React.FC<AchievementBadgeProps> = ({ 
  icon, 
  size = 24,
  className = ''
}) => {
  const Icon = iconMap[icon] || Trophy;

  return (
    <div className={`rounded-full p-2 bg-gradient-to-br from-purple-500 to-pink-500 text-white ${className}`}>
      <Icon size={size} />
    </div>
  );
};

export default AchievementBadge;